/**
 * Props for SignupScreen component
 * Contains form state and handlers
 */
export interface SignupScreenBaseProps {
  formData: {
    email: string
    password: string
    confirmPassword: string
  }
  showPassword: boolean
  showConfirmPassword: boolean
  acceptTerms: boolean
  loading: boolean
  error: string
  onFormDataChange: (updates: Partial<{ email: string; password: string; confirmPassword: string }>) => void
  onShowPasswordChange: (show: boolean) => void
  onShowConfirmPasswordChange: (show: boolean) => void
  onAcceptTermsChange: (accept: boolean) => void
  onClearField: (field: 'email' | 'password' | 'confirmPassword') => void
  onSubmit: (e: React.FormEvent) => void
}

/**
 * Default form data for signup
 */
export const getDefaultSignupFormData = () => ({
  email: '',
  password: '',
  confirmPassword: ''
})

/**
 * Password strength calculator
 */
export const getPasswordStrength = (password: string) => {
  if (password.length === 0) return { level: 0, text: '', color: '', bgColor: '' }
  if (password.length < 6) return { level: 1, text: 'Weak', color: '#F7A179', bgColor: '#F7A179' }
  if (password.length < 8) return { level: 2, text: 'Weak', color: '#F8DB7A', bgColor: '#F8DB7A' }
  if (password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/)) {
    return { level: 4, text: 'Strong', color: '#98D46E', bgColor: '#98D46E' }
  }
  return { level: 3, text: 'Good', color: '#275098', bgColor: '#80ADFB' }
}

